import {
  ResourceBar,
  type ResourceBarProps,
} from "@thilke/ui/components/resource-bar";
import { cn } from "@thilke/ui/lib/utils";

interface XpBarProps extends ResourceBarProps {
  levelUpMessage?: string;
}

function XpBar({
  className,
  levelUpMessage = "LEVEL UP!",
  value = 0,
  ...props
}: XpBarProps) {
  const isLevelUp = (value ?? 0) >= 100;

  return (
    <div className={cn("relative", className)}>
      <ResourceBar
        {...props}
        value={value}
        className="h-full"
        indicatorClassName="bg-accent"
      />
      {isLevelUp ? (
        <span className="absolute inset-0 flex items-center justify-center text-[0.625rem] font-semibold text-accent-foreground">
          {levelUpMessage}
        </span>
      ) : null}
    </div>
  );
}

export default XpBar;
export type { XpBarProps };
export { XpBar };
